import React from 'react';
import Photo from './Photo';
import PhotoShare from './Share/PhotoShare';
import PhotoRemoteSubmission from './RemoteSubmission/PhotoRemoteSubmission';
const PhotoWrapper = ({ isShare = false, isRemoteSubmission = false, ...rest }) => {
    if (isRemoteSubmission) {
        return React.createElement(PhotoRemoteSubmission, { ...rest });
    }
    if (isShare) {
        return React.createElement(PhotoShare, { ...rest });
    }
    return React.createElement(Photo, { ...rest });
};
export default PhotoWrapper;
